module.exports = __webpack_public_path__ + "static/assets/0787df0fe748fcbb41324ed90bf4a2ac.svg";